// SEO Schema.org structured data for case study pages
export const generateCaseStudySchema = (caseData: {
    title: string;
    description: string;
    image: string;
    datePublished?: string;
    author?: string;
    organization?: string;
    articleBody?: string;
}) => {
    return {
        '@context': 'https://schema.org',
        '@type': 'CaseStudy',
        headline: caseData.title,
        description: caseData.description,
        image: caseData.image,
        datePublished: caseData.datePublished,
        author: {
            '@type': 'Organization',
            name: caseData.author || 'Osperb',
        },
        provider: {
            '@type': 'Organization',
            name: caseData.organization || 'Osperb',
        },
    };
};

export const generateOrganizationSchema = () => {
    return {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Osperb',
        url: 'https://osperb.com',
        logo: 'https://osperb.com/logo.png',
        description: 'Custom e-commerce and enterprise software solutions',
        sameAs: [
            'https://www.facebook.com/osperb',
            'https://www.linkedin.com/company/osperb',
            'https://twitter.com/osperb',
        ],
    };
};

export const generateBreadcrumbSchema = (breadcrumbs: { name: string; url: string }[]) => {
    return {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumbs.map((crumb, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: crumb.name,
            item: crumb.url,
        })),
    };
};

export const SEO_KEYWORDS = {
    buildex:
        'enterprise e commerce case study, custom ecommerce development, custom coded ecommerce platform, gcc ecommerce development for gcc dubai oman saudi qatar, oman ecommerce app, enterprise ecommerce website, microservices ecommerce, sap erp ecommerce integration, sap id mapping, bank muscat payment gateway integration, arabic english ecommerce, vat ready checkout, click and collect ecommerce, b2c ecommerce system, scalable ecommerce architecture',
};
